import { SelectItem } from '@/types/ui';

const mapHierarchicalOptionsForIndicationMode = (
  row: Record<string, unknown>,
  dimensions: string[],
): SelectItem<string> => {
  const segments = dimensions
    .map(dimension => {
      if (row[dimension] == null) return null;
      const normalized = row[dimension].toString().trim().replace(/\s+/g, ' ');
      if (normalized === 'N/A') return null;

      return normalized.length ? normalized : null;
    })
    .filter((segment): segment is string => segment != null);

  const path = segments.join('__');
  return { label: path, value: path };
};

export default mapHierarchicalOptionsForIndicationMode;
